import React from "react";
import useSEO from "../hooks/useSEO";
import { motion } from "framer-motion";
import "./Privacy.css";

const Privacy = () => {
  useSEO({
    title: "La Psicologa Anna | Privacy",
    description: "Privacy policy del portale La Psicologa Anna.",
  });

  return (
    <motion.div
      className="page prenota-appuntamento-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="privacy-page">
        <h1>Privacy Policy</h1>
        <p>
          Questa informativa è redatta ai sensi del Regolamento (UE) 2016/679
          (GDPR) e del Codice in materia di protezione dei dati personali
          italiano, in conformità alle indicazioni del Garante per la protezione
          dei dati personali.
        </p>

        <p>
          <strong>Titolare del trattamento dei dati</strong>
          <br />
          Dott.ssa Anna Antoniozzi
          <br />
          Psicologa iscritta all'Albo Lazio n. 28800
          <br />
          Email: annaantoniozzipsicologa@gmail.com
        </p>

        <h2>Tipologie di dati raccolti</h2>
        <p>
          Il sito non raccoglie dati personali direttamente dagli utenti tramite
          moduli, registrazioni o newsletter. Tuttavia, possono essere trattati
          dati tecnici (es. indirizzo IP, tipo di browser, interazioni) tramite
          strumenti esterni come Google Analytics e il widget MioDottore, attivi
          solo previo consenso.
        </p>

        <h2>Finalità del trattamento</h2>
        <p>
          Il sito ha esclusivamente finalità informativa e non effettua raccolta
          diretta di dati personali.
        </p>

        <h2>Redirect verso servizi esterni</h2>
        <p>
          Il sito può contenere link o redirect verso piattaforme esterne (es.
          servizi di prenotazione o portali professionali). In tali casi, ti
          invitiamo a consultare le rispettive privacy policy, in quanto operano
          in modo indipendente.
        </p>

        <h2>Servizi esterni incorporati</h2>
        <p>
          Il sito integra un widget fornito da <strong>MioDottore.it</strong>{" "}
          (Docplanner Group) per consentire la prenotazione online delle visite.
          Questo strumento potrebbe raccogliere dati tecnici e comportamentali
          (es. indirizzo IP, tipo di browser, interazioni con il widget), anche
          tramite cookie di terze parti. Per maggiori informazioni sul
          trattamento dei dati si rimanda alla{" "}
          <a
            href="https://www.miodottore.it/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy di MioDottore
          </a>
          .
        </p>
        <h2>Cookie e strumenti di terze parti</h2>
        <p>
          Il sito utilizza cookie tecnici e, previo consenso, strumenti di
          analisi statistica (es. Google Analytics). Questi strumenti possono
          raccogliere dati aggregati e anonimi, come l'indirizzo IP
          anonimizzato, il tipo di dispositivo e il comportamento di
          navigazione.
        </p>
        <p>
          I cookie di analisi sono disattivati di default e vengono abilitati
          solo dopo il tuo consenso, che puoi revocare eliminando i cookie dal
          tuo browser.
        </p>

        <p>
          Per maggiori informazioni consulta la{" "}
          <a href="/cookie-policy">Cookie Policy</a>.
        </p>

        <h2>Base giuridica del trattamento</h2>
        <p>
          Il trattamento, laddove presente, avviene sulla base del consenso
          espresso tramite il banner dei cookie, o per il legittimo interesse
          del titolare a garantire la sicurezza e il corretto funzionamento del
          sito.
        </p>

        <h2>Diritti dell'interessato</h2>
        <p>
          Hai diritto di ottenere informazioni sull'eventuale trattamento dei
          tuoi dati, richiederne l'accesso, la rettifica, la cancellazione o la
          limitazione, nei limiti previsti dagli artt. 15-22 del Regolamento UE
          2016/679 (GDPR).
        </p>

        <h2>Modifiche a questa privacy policy</h2>
        <p>
          La presente informativa può essere soggetta ad aggiornamenti. Ti
          invitiamo a consultarla periodicamente.
        </p>

        <p>
          <em>Ultimo aggiornamento: dicembre 2025</em>
        </p>
      </div>
    </motion.div>
  );
};

export default Privacy;
